'use strict';

exports.__esModule = true;
exports.KEY = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // for async/await work flow

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY = exports.KEY = '__pending__';

// A wrapper for convenience and to work with pending
// ops in an efficient way.

var PendingOps = function () {
  function PendingOps(storage, ops) {
    _classCallCheck(this, PendingOps);

    this.check = this.check.bind(this);

    this.storage = storage;
    this.ops = ops;
    this.seen = _ronUuid.ZERO;
    return this;
  }

  PendingOps.prototype.setIdlePeriod = function setIdlePeriod(period) {
    this.period = period;
    this.check();
  };

  PendingOps.prototype.onIdle = function onIdle(f) {
    this._onIdle = f;
  };

  /*:: @@iterator(): Iterator<string> { return ({}: any); } */

  // $FlowFixMe - computed property
  PendingOps.prototype[Symbol.iterator] = function () {
    return this.ops[Symbol.iterator]();
  };

  PendingOps.prototype.push = function push(frame) {
    this.ops.push(frame);
    return this.flush();
  };

  PendingOps.prototype.release = function release(ack) {
    if (this.seen.gt(ack)) return Promise.resolve();
    this.seen = ack;
    var i = -1;
    for (var _iterator = this.ops, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var _old = _ref;

      i++;
      var old = _ron2.default.fromString(_old);
      if (!old) throw new Error('malformed op: \'' + _old + '\'');

      if (old.event.gt(ack)) {
        this.ops = this.ops.slice(i + 1);
        break;
      }
    }
    if (i === this.ops.length - 1) this.ops = [];

    return this.flush();
  };

  PendingOps.prototype.flush = function flush() {
    return this.storage.set(KEY, JSON.stringify(this.ops));
  };

  PendingOps.read = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee(storage) {
      var pending;
      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return storage.get(KEY);

            case 2:
              pending = _context.sent;
              return _context.abrupt('return', new PendingOps(storage, JSON.parse(pending || '[]')));

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function read(_x) {
      return _ref2.apply(this, arguments);
    }

    return read;
  }();

  PendingOps.prototype.check = function check() {
    clearTimeout(this.timer);
    if (this.ops.length && this._onIdle) this._onIdle();
    if (this.period > 0) {
      this.timer = setTimeout(this.check, this.period);
    }
  };

  _createClass(PendingOps, [{
    key: 'length',
    get: function get() {
      return this.ops.length;
    }
  }]);

  return PendingOps;
}();

exports.default = PendingOps;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/client/lib/pending.js
// module id = 76
// module chunks = 0